import {stringify} from 'query-string';
import {SNS_IMAGES} from '@px/const/images';

const regionReferralMap = {
  en: ['twitter', 'facebook', 'telegram', 'linkedin', 'reddit', 'microblog'],
  ru: ['vk', 'twitter', 'facebook', 'telegram', 'linkedin', 'reddit', 'whatsapp'],
  es: ['whatsapp', 'snapchat', 'twitter', 'facebook', 'telegram', 'linkedin'],
  tr: ['whatsapp', 'facebook', 'twitter', 'telegram'],
  pt: ['facebook', 'twitter', 'whatsapp', 'linkedin'],
  other: ['twitter', 'facebook', 'telegram', 'linkedin', 'reddit'],
};

export function genSnsShareInfo(region, referralLink, text, shareImg = '', customRegions) {
  if (!(region || customRegions) || !referralLink) return [];

  const linkMap = {
    facebook: `https://www.facebook.com/sharer.php?${stringify({
      u: referralLink + '&media=facebook',
    })}`,
    twitter: `https://twitter.com/share?${stringify({
      text,
      url: referralLink + '&media=twitter',
    })}`,
    telegram: `https://telegram.me/share/url?${stringify({
      text,
      url: referralLink + '&media=telegram',
    })}`,
    microblog: `http://v.t.sina.com.cn/share/share.php?${stringify({
      title: text,
      url: referralLink + '&media=microblog',
      pic: shareImg,
    })}`,
    linkedin: `https://www.linkedin.com/shareArticle?${stringify({
      title: text,
      url: referralLink + '&media=linkedin',
    })}`,
    reddit: `https://reddit.com/submit?${stringify({
      title: text,
      url: referralLink + '&media=reddit',
    })}`,
    vk: `https://vk.com/share.php?${stringify({
      url: referralLink + '&media=vk',
    })}`,
    whatsapp: `https://web.whatsapp.com/send?${stringify({
      text: referralLink + '&media=whatsapp',
    })}`,
    snapchat: `https://snapchat.com/scan?${stringify({
      attachmentUrl: referralLink + '&media=snapchat',
      utm_source: 'phemex',
    })}`,
  };

  if (customRegions && customRegions.length > 0) {
    return customRegions.map((item) => ({...matchMedia(item.name), ...item}));
  }

  const medias = regionReferralMap[region] ? regionReferralMap[region] : regionReferralMap.other;

  return medias.map(matchMedia);

  function matchMedia(media) {
    return {
      media,
      link: linkMap[media],
      img: SNS_IMAGES[`${media.toUpperCase()}_IMG`],
    };
  }
}

export function createSnsShareViews({referralLink, shareText, shareImg}) {
  const regions = [
    {name: 'twitter', img: SNS_IMAGES.TWITTER_IMG},
    {name: 'telegram', img: SNS_IMAGES.TELEGRAM_IMG},
    {name: 'linkedin', img: SNS_IMAGES.LINKEDIN_IMG},
    {name: 'facebook', img: SNS_IMAGES.FACEBOOK_IMG},
    {name: 'reddit', img: SNS_IMAGES.REDDIT_IMG},
  ];
  return genSnsShareInfo('', referralLink, shareText, shareImg, regions);
}

export function createReferralLink({fixLink, path, referralCode}) {
  if (path) {
    return location.origin + fixLink(path) + `?referralCode=${referralCode}`;
  }
  return location.origin + location.pathname + `?referralCode=${referralCode}`;
}
